import React from 'react';
import Confirmation from '../partials/Confirmation';
import '../../assets/css/FormHome.css';
import Wobble from 'react-reveal/Wobble';
import axios from 'axios';
import fitty from 'fitty';

class Contact extends React.Component {
    state = {
        name: "",
        email: "",
        phone: "",
        message: "",
        sent: false
    }
    handleSubmit = (e) => {
        e.preventDefault();
        axios.post('api/inbox', this.state).then(res => {
            console.log(res)
            if (res.data === "success") {
                this.setState({ sent: true })
            }
        })
    }
    nameHandleChange = (e) => {
        this.setState({ name: e.target.value });
    }
    emailHandleChange = (e) => {
        this.setState({ email: e.target.value });
    }
    phoneHandleChange = (e) => {
        this.setState({ phone: e.target.value });
    }
    messageHandleChange = (e) => {
        this.setState({ message: e.target.value });
    }
    componentDidMount() {
        document.title = "Contact us";
    }
    render() {
        return (
            <>
                <div className="formbg">
                    <div className="formContainer" >
                        <div className='formLeft'>
                            <h1 className='FormTitle'>CONTACT US</h1>
                            <p style={{ paddingTop: '30px', paddingBottom: '20px' }}>Whether you are looking for a custom-built one-of-a-kind home or a home that is a part of our beautifully-designed communities, Signature Move Investment Group offers it all.</p>
                            <p style={{ paddingBottom: '20px' }}>To inquire, please fill in the form with any questions you may have on our current inventory or any upcoming developments</p>
                            <p className='contactInfo'><a href='mailto:signaturemoveig@gmail.com'>signaturemoveig@gmail.com</a> |  +1 410 204 4070</p>
                            <p>Baltimore Maryland, 21211</p>
                            <p>1014 W 36th St</p>
                            <p>Unit #52</p>
                            <p>United States</p>

                        </div>
                        <div className='formRight'>
                            {this.state.sent === false ?
                                <form onSubmit={this.handleSubmit} method="POST" action="/inbox" >
                                    <label>Name</label>
                                    <input type="text" required value={this.state.name} onChange={this.nameHandleChange} />
                                    <label>Email</label>
                                    <input type="email" required value={this.state.email} onChange={this.emailHandleChange} />
                                    <label>Phone</label>
                                    <input type="phone" required value={this.state.phone} onChange={this.phoneHandleChange} />
                                    <label>Your message</label>
                                    <textarea rows="6" cols="20" maxLength="250" required="required" value={this.state.message} onChange={this.messageHandleChange}></textarea>
                                    <input style={{ cursor: "pointer" }} type="submit" className="btnStyle btnActive" value="Send message" />
                                </form> : <Wobble duration={1220} top> <Confirmation message="Message sent"></Confirmation> </Wobble>}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
export default Contact;
